<template>
  <div>
    <div class="card datepickerwrap">
      <div class="d-flex gap-3 tw-justify-between tw-items-center">
        <div class="d-flex gap-3 flex-wrap tw-items-center">
          <div class="mr-2">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Date"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              style="width: 150px"
              v-model="lossBuyboxTableDateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDateTableDateRange"
              :max-date="maxDateTableDateRange"
              :single-date-picker="true"
              :ranges="false"
            >
              <!-- @update="getBuyBoxTable" -->
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 160px; max-width: 160px"
             id="disparity-filters"
          >
            <div
              class="mb-1 ml-0"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
             
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>

            <multiselect
              v-model="selectedPlatform"
              class="text-capitalize"
              :options="platformList"
              track-by="key"
              label="value"
              :custom-label="updateSelectedLabels"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              @input="handlePlatformSelection"
               :limit="
                selectedPlatform?.length == platformList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedPlatform"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value.replaceAll("_", " ") }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 160px; max-width: 160px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #050a1380"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableCategory"
              class="text-capitalize"
              :options="categoryList"
              track-by="key"
              label="value"
              placeholder="Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              disabled
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 160px; max-width: 160px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #050a1380"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableSubCategory"
              class="text-capitalize"
              :options="subCategoryList"
              track-by="key"
              label="value"
              placeholder="Sub Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              disabled
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableSubCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 160px; max-width: 160px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #050a1380"
            >
              {{ translatedLang["Brand"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBrand"
              class="text-capitalize"
              :options="lossBrandList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              disabled
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBrand"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <!-- <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template> -->
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 160px; max-width: 160px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #050a1380"
            >
              {{ translatedLang["Price Range"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedPriceRange"
              class="text-capitalize"
              :options="lossPriceRangeList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Price Range"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              disabled
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedPriceRange"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 160px; max-width: 160px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #050a1380"
            >
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedProduct"
              limit="1"
              :options="lossProductList"
              :multiple="true"
              :searchable="false"
              placeholder="Select Product"
              :close-on-select="false"
              :allow-empty="true"
              :showLabels="false"
              track-by="key"
              label="value"
              disabled
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="lossSelectedProduct"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="custom_pincode_dropdown customMultiselect mr-3"
            style="min-width: 160px; max-width: 160px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Pincode"][selectedLanguage.key] }}
            </div>
            <treeselect
              v-model="lossSelectedPIN"
              :options="lossPINList"
              track-by="id"
              label="label"
              value-consists-of="LEAF_PRIORITY"
              limit="1"
              :disable-branch-nodes="false"
              placeholder="Select PIN(s)"
              :multiple="true"
              :searchable="true"
            >
              <span slot="noResult">{{
                translatedLang["No elements found"][selectedLanguage.key]
              }}</span>
            </treeselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 160px; max-width: 160px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBatch"
              class="text-capitalize"
              :options="lossBatchList"
              track-by="batch"
              label="displayname"
              :multiple="false"
              :searchable="false"
              placeholder="Select Batch"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="true"
            >
              <template #option="{ option }">
                <span class="option__title ml-3 text-capitalize">{{
                  option.displayname.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <button
            class="btn primarycolor py-2 tw-mt-4"
            @click="handleApplyFilters"
          >
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>
        <button
          @click="handleBack"
          class="navigationButton tw-flex tw-items-center tw-gap-2"
          type="button"
        >
          <span> {{ translatedLang["Back"][selectedLanguage.key] }}</span>
        </button>
      </div>
    </div>
    <div v-if="tableLoader">
      <Loader />
    </div>
    <div class="card mx-2 revampCard">
      <div>
        <div class="borderBottom d-flex align-items-center tw-px-4">
          <h4 class="graphHeading mr-2" style="margin-bottom: 12px !important">
            {{ translatedLang["Price Tracking"][selectedLanguage.key] }}
          </h4>
        </div>
        <div class="summaryContainer mt-3" v-if="priceTrackingtableDataShow">
          <table
            class="table"
            id="price-tracking-table"
            style="width: 100%; overflow: hidden"
          >
            <thead class="thead-normal">
              <tr>
                <th
                  style="padding: 10px 0 !important"
                  scope="col"
                  v-for="th in storePriceTableData.header"
                  :key="th.key"
                  class="p-2"
                >
                  <div
                    v-if="th.img"
                    class="tw-flex tw-justify-center tw-items-center tw-gap-1"
                  >
                    <img :src="th.img" style="width: 19px; max-height: 19px" />
                    {{ th.label }}
                  </div>
                  <div v-else>{{ th.label }}</div>
                </th>

                <th>{{ translatedLang["TrendLine"][selectedLanguage.key] }}</th>
              </tr>
            </thead>
            <tbody class="tbody-normal">
              <tr v-for="(row, i) in storePriceTableData.data" :key="i">
                <td v-for="(d, j) in storePriceTableData.header" :key="j" :class="{
                      'tw-max-w-[200px]':
                        d.key === 'product_name',
                    }">
                  <div
                    v-if="d.key == 'product_name'" class="tw-max-w-[600px]  tw-text-wrap"
                  >
                    <div
                      class="text-capitalize tw-py-9  tw-text-[#0463BA]"
                      v-if="!row.child"
                    >
                      {{ row[d.key] }}
                    </div>
                    <div class="tw-text-[#5E5E5E] tw-py-4 " v-else>
                      {{ row[d.key] }}
                    </div>
                  </div>
                  <div v-if="d.key == 'pincode'">
                    <span class="text-capitalize">{{ row[d.key] }}</span>
                  </div>
                  <div v-if="d.key == 'mrp'">
                    <span
                      class="text-capitalize"
                      :class="[
                        row[d.key] == 'Out Of Stock' && 'outOfStockColor',
                      ]"
                      >{{ row[d.key] }}</span
                    >
                  </div>

                  <div class="d-flex justify-content-center align-items-center">
                    <div
                      v-if="row.platform[d.key]"
                      class="tw-flex tw-gap-2 tw-items-center"
                    >
                      <div
                        :class="[
                          row.platform[d.key].original_price ===
                            'Out Of Stock' && 'outOfStockColor',
                        ]"
                      >
                        {{ row.platform[d.key].original_price }}
                      </div>
                      <div
                        class="text-success tw-flex tw-gap-1 tw-items-center"
                        v-if="
                          checkPriceDiff(row.platform[d.key].price_diff) == 'up'
                        "
                      >
                        <img
                          style="width: 8px; height: 8px; color: green"
                          class="mb-1 mr-1"
                          src="../../../public/Icons_SVG/upPriceArrow.svg"
                        />
                        <!-- {{ row.platform[d.key].percentage_change }} -->
                      </div>
                      <div
                        class="outOfStockColor tw-flex tw-gap-1 tw-items-center"
                        v-if="
                          checkPriceDiff(row.platform[d.key].price_diff) ==
                          'down'
                        "
                      >
                        <img
                          style="width: 8px; height: 8px"
                          class="mb-1 mr-1"
                          src="../../../public/Icons_SVG/downPriceArrow.svg"
                        />
                        <!-- {{ row.platform[d.key].percentage_change }} -->
                      </div>
                    </div>
                  </div>
                </td>
                <td style="width: 2%">
                  <div
                    @click="
                      processTrendLineModal(
                        row.product_name,
                        row.sku,
                        row.pincode,
                        row.child
                      )
                    "
                    class="icon tw-cursor-pointer"
                  >
                    <i class="fa fa-line-chart"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-else-if="!priceTrackingtableDataShow && tableloader"
          class="onLoadingData"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger tw-mt-4 d-flex justify-content-center border border-danger rounded p-2 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>
    </div>
    <b-modal
      size="xl"
      class="customModal"
      id="trendLineModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showTrendLineModal"
      :title="selectedProductTrendlineModal"
    >
      <div class="tw-flex tw-gap-4">
        <div>
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Date Range"][selectedLanguage.key] }}
          </div>
          <date-range-picker
            v-model="modelTrendlineDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minModelTrendlineDateRange"
            :max-date="maxModelTrendlineDateRange"
            @update="getModalTrendlineGraphData"
          >
          </date-range-picker>
        </div>
        <div
          class="customMultiselectCommon"
          style="min-width: 160px; max-width: 160px"
          id="disparity-filters"
        >
          <div
            class="mb-1 ml-0"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Platform"][selectedLanguage.key] }}
          </div>

          <multiselect
            v-model="selectedModelTrendlinePlatform"
            class="text-capitalize"
            :options="platformList"
            track-by="key"
            label="value"
            :custom-label="updateSelectedLabels"
            :multiple="true"
            :searchable="false"
            placeholder="Select Platform"
            :showLabels="false"
            :close-on-select="false"
            :allow-empty="true"
            @input="handleModelPlatformSelection"
            :limit="
                selectedModelTrendlinePlatform?.length == platformList?.length ? 1 : 100
              "
          >
            <template #option="{ option }">
              <div class="tw-flex tw-gap-2">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedModelTrendlinePlatform"
                />
                <div class="custom-option text-capitalize">
                  {{ option.value.replaceAll("_", " ") }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="custom_pincode_dropdown customMultiselect mr-3"
          style="min-width: 160px; max-width: 160px"
        >
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Pincode"][selectedLanguage.key] }}
          </div>
          <treeselect
            v-model="selectedPinTrendLineModal"
            :options="lossPINList"
            track-by="id"
            label="label"
            value-consists-of="LEAF_PRIORITY"
            limit="1"
            :disable-branch-nodes="true"
            placeholder="Select PIN(s)"
            :multiple="false"
            :searchable="true"
            @input="getModalTrendlineGraphData"
          >
            <span slot="noResult">{{
              translatedLang["No elements found"][selectedLanguage.key]
            }}</span>
          </treeselect>
        </div>
      </div>
      <div class="p-2" id="#modalContainer">
        <div>
          <div
            v-if="
              onPriceTabletrendLineShowData &&
              Object.keys(procedModalTrandLineData).length
            "
            class="mt-2"
          >
            <lineChart
              :data="procedModalTrandLineData"
              :key="Date.now() + 'data'"
            />
          </div>
          <div
            v-else-if="
              !onPriceTabletrendLineShowData &&
              (firstTimeTrendLineLoader || trendLineGraphLoader)
            "
            class="onLoadingData mt-2"
          >
            {{ translatedLang["Loading"][selectedLanguage.key] }}...
          </div>
          <div
            v-else
            class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData mt-3"
            style="font-family: Poppins"
          >
            {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
          </div>
        </div>
      </div>
    </b-modal>
    <div class="card mx-2 revampCard">
      <div class="borderBottom d-flex align-items-center tw-px-4">
        <h4 class="graphHeading mr-2" style="margin-bottom: 12px !important">
          {{ translatedLang["Parent VS Child"][selectedLanguage.key] }}
        </h4>
      </div>
      <div class="tw-flex tw-gap-6 tw-mt-5 tw-mx-2">
        <div>
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Date Range"][selectedLanguage.key] }}
          </div>
          <date-range-picker
            v-model="trendlineDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minTrendlineDateRange"
            :max-date="maxTrendlineDateRange"
            @update="getTrendlineData"
          >
            <!-- @update="getBuyBoxTable" -->
          </date-range-picker>
        </div>
        <div
          class="customMultiselectCommon"
          style="min-width: 180px; max-width: 180px"
        >
          <div
            class="mb-1 ml-0"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Platform"][selectedLanguage.key] }}
          </div>

          <multiselect
            v-model="selectedTrendlinePlatform"
            class="text-capitalize"
            :options="trendlinePlatformList"
            track-by="key"
            label="value"
            :custom-label="updateSelectedLabels"
            :multiple="false"
            :searchable="false"
            placeholder="Select Platform"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="true"
            @input="handleTrendlinePlatformSelection"
          >
          </multiselect>
        </div>
        <div
          class="custom_pincode_dropdown customMultiselect"
          style="min-width: 160px; max-width: 160px"
        >
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            {{ translatedLang["Pincode"][selectedLanguage.key] }}
          </div>
          <treeselect
            v-model="trendlinePincode"
            :options="lossPINList"
            track-by="id"
            label="label"
            value-consists-of="LEAF_PRIORITY"
            limit="1"
            :disable-branch-nodes="true"
            placeholder="Select PIN(s)"
            :multiple="false"
            :searchable="true"
            @input="handleTrendlinePlatformSelection"
          >
            <span slot="noResult">{{
              translatedLang["No elements found"][selectedLanguage.key]
            }}</span>
          </treeselect>
        </div>
      </div>
      <div v-if="trendlineDataShow">
        <dynamicChart
          :data="proccedNetSalesGraphData"
          :isLegend="true"
          :height="400"
        />
      </div>
      <div
        v-else-if="!trendlineDataShow && trendlineLoader"
        class="onLoadingData"
      >
        {{ translatedLang["Loading"][selectedLanguage.key] }}...
      </div>
      <div
        v-else
        class="text-danger tw-mt-4 d-flex justify-content-center border border-danger rounded p-2 noData"
      >
        {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import dynamicChart from "../commonCharts/Chart/dynamicChart.vue";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import lineChart from "../commonCharts/lineChart.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";

export default {
  name: "PriceTrackingDisparity",
  components: {
    Multiselect,
    Datepicker,
    Loader,
    Treeselect,
    dynamicChart,
    lineChart,
  },
  data() {
    return {
      lossBuyboxTableDateRange: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      minDateTableDateRange: "",
      maxDateTableDateRange: "",
      trendlineDateRange: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      minTrendlineDateRange: "",
      maxTrendlineDateRange: "",
      modelTrendlineDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      minModelTrendlineDateRange: "",
      maxModelTrendlineDateRange: "",
      selectedPlatform: [],
      platformList: [],
      selectedTableCategory: [],
      categoryList: [],
      categoryTableList: "",
      selectedTableSubCategory: [],
      subCategoryList: [],
      lossSelectedBrand: [],
      lossBrandList: [],
      lossSelectedProduct: [],
      lossProductList: [],
      lossSelectedPIN: [],
      lossPINList: [],
      lossSelectedBatch: [],
      lossBatchList: [],
      uploadedProducts: {},
      allPincodeList: [],
      finalSelectedCategory: [],
      previousSelection: [],
      previousModelPlatformSelection: [],
      lossSelectedPriceRange: [],
      lossPriceRangeList: [],
      finalSelectedCategory: [],
      storeAllDataForStatus: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      storePriceTableData: {
        header: [
          { key: "product_image", value: "product Image" },
          { key: "product_name", value: "product Name" },
        ],
        data: [],
      },
      priceTrackingtableDataShow: false,
      trendlineDataShow: false,
      tableloader: true,
      trendlineLoader: true,
      tableLoader: false,
      viewNetSalesData: "",
      proccedNetSalesGraphData: {},
      selectedTrendlinePlatform: [],
      selectedModelTrendlinePlatform: [],
      trendlinePlatformList: [],
      trendlinePincode: null,
      showTrendLineModal: false,
      selectedProductTrendlineModal: "",
      procedModalTrandLineData: { xAxis: [] },
      viewModalTrendLineData: [],
      trendLineGraphLoader: false,
      firstTimeTrendLineLoader: false,
      selectedProductTrendlineModal: "",
      storeSKUForTrendLineModal: "",
      selectedPinTrendLineModal: "",
      // selectedTrendlinePlatform: "",
      platformColor: {
        swiggy: "#FB8019",
        zepto: "#70339c",
        flipkart_grocery: "#4B659C",
        amazon: "#D48722",
        dmart: "#61B093",
        jiomart: "#FD5542",
        bigbasket: "#666872",
        blinkit: "#F8CC44",
        amazon_retail: "#231F20",
        flipkart: "#2874f0",
        boat: "#ED1C24",
        noon: "#E1D00D",
      },
      onPriceTabletrendLineShowData: false,
      isChild: false,
    };
  },
  mounted() {
    const storedData = this.$store.state.DemoStore.disparityProductDetails;
    this.lossBuyboxTableDateRange = storedData.selectedDateRange;
    this.selectedPlatform = storedData.selectedPlatform;
    this.previousSelection = [...this.selectedPlatform];
    this.selectedTableCategory = storedData.selectedCategory;
    this.selectedTableSubCategory = storedData.selectedSubCategory;
    this.lossSelectedBrand = storedData.selectedBrand;
    this.lossSelectedProduct = storedData.selectedProduct;
    this.lossSelectedPIN = storedData.selectedPincode;
    this.lossSelectedBatch = storedData.selectedBatch;
    this.lossSelectedPriceRange = storedData.selectedPriceRange;
    this.getLastUpdatedDates();
    this.getFiltersData();
  },

  computed: {
    ...mapState("DemoStore", [
      "selectedLanguage",
      "translatedLang",
      "disparityProductDetails",
    ]),
  },
  watch: {
    showTrendLineModal(prevVal) {
      if (!prevVal) {
        this.selectedPinTrendLineModal = "";
        setTimeout(() => {
          this.onPriceTabletrendLineShowData = false;
        }, 200);
      }
    },
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "setSelectedDisparityFilters",
      "initializeTranslation",
    ]),
    getColorForKey(key) {
      let updateKey = key.toLowerCase().replaceAll(" ", "_");
      return this.platformColor[updateKey] || "#333";
    },
    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },
    checkPriceDiff(value) {
      if (value > 0) {
        return "up";
      } else if (value < 0) {
        return "down";
      }
    },
    handleApplyFilters() {
      this.$store.dispatch("DemoStore/setSelectedDisparityFilters", {
        selectedDateRange: {
          startDate: this.lossBuyboxTableDateRange.startDate,
          endDate: this.lossBuyboxTableDateRange.endDate,
        },
        selectedPlatform: this.selectedPlatform,
        selectedPincode: this.lossSelectedPIN,
        selectedBatch: this.lossSelectedBatch,
      });
      if ($.fn.DataTable.isDataTable("#price-tracking-table")) {
        $("#price-tracking-table").DataTable().destroy();
      }
      this.priceTrackingtableDataShow = false;
      this.getTableData();
      this.getTrendlineData();
    },
    handleBack() {
      this.$router.go(-1);
    },
    getLastUpdatedDates() {
      this.tableLoader = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}`;
      this.$http
        .get(url)
        .then((response) => {
          localStorage.price_tracking_last_update = JSON.stringify(
            response.body.data.price_tracking
          );
          //   this.lossBuyboxTableDateRange.endDate = moment(
          //     response.body.data.price_tracking.end_date
          //   ).format("YYYY-MM-DD");
          //   this.lossBuyboxTableDateRange.startDate = moment(
          //     response.body.data.price_tracking.end_date
          //   ).format("YYYY-MM-DD");
          this.maxDateTableDateRange = new Date(
            response.body.data.price_tracking.end_date
          );
          this.maxTrendlineDateRange = new Date(
            response.body.data.price_tracking.end_date
          );
          this.maxModelTrendlineDateRange = new Date(
            response.body.data.price_tracking.end_date
          );
        })
        .catch((err) => {
          this.tableLoader = false;
          // this.getBrandDetails();
          console.log("err", err);
        })
        .finally(() => {
          this.tableLoader = false;
        });
    },
    getFiltersData() {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.platformList = [...response.data.data.platform];
          this.trendlinePlatformList = [...response.data.data.platform];
          this.selectedTrendlinePlatform = this.trendlinePlatformList[0];
          if (this.platformList.length) {
            this.platformList.unshift({ key: "All", value: "All" });
          }
          this.lossPriceRangeList = response.data.data.price_range;

          //   this.selectedPlatform = [...this.platformList];
          //   this.previousSelection = [...this.selectedPlatform];
          if (Object.keys(response.data.data.batch).length) {
            this.lossBatchList = response.data.data.batch["price tracking"];
            this.lossSelectedBatch = this.lossBatchList[0];
            this.batchList = response.data.data.batch["price tracking"];
          }
          this.allCategory = response.data.data.category;
          this.categoryList = [];
          this.subCategoryList = [];
          const categoryMap = new Map();

          this.platformList.forEach((platform) => {
            const platformKey = platform.key;
            const categories = this.allCategory[platformKey];

            if (categories?.length) {
              categories.forEach((cat) => {
                if (!categoryMap.has(cat.key)) {
                  categoryMap.set(cat.key, cat);
                  this.categoryList.push(cat);
                }
              });
            }
          });

          const stateMap = new Map();

          this.selectedPlatform.forEach((platform) => {
            const platformKey = platform.key;
            const states = response.data.data.pincode[platformKey] || [];

            states.forEach((state) => {
              if (!stateMap.has(state.id)) {
                stateMap.set(state.id, {
                  id: state.id,
                  label: state.label,
                  children: [],
                });
              }

              const stateEntry = stateMap.get(state.id);
              const cityMap = new Map(
                stateEntry.children.map((city) => [city.id, city])
              );

              state.children?.forEach((city) => {
                if (!cityMap.has(city.id)) {
                  cityMap.set(city.id, {
                    id: city.id,
                    label: city.label,
                    children: [],
                  });
                }

                const cityEntry = cityMap.get(city.id);
                const pinMap = new Map(
                  cityEntry.children.map((pin) => [pin.id, pin])
                );

                city.children?.forEach((pin) => {
                  if (!pinMap.has(pin.id)) {
                    pinMap.set(pin.id, {
                      id: pin.id,
                      label: pin.label,
                    });
                  }
                });

                cityEntry.children = Array.from(pinMap.values());
              });

              stateEntry.children = Array.from(cityMap.values());
            });
          });

          this.lossPINList = Array.from(stateMap.values());
          this.allPincodeList = response.data.data.pincode;
          this.getTableData();
          this.getTrendlineData();
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    handlePlatformSelection(selected) {
      const otherOptions = this.platformList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedPlatform = [...this.platformList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedPlatform = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedPlatform = [...this.platformList];
        } else {
          this.selectedPlatform = [...selectedWithoutAll];
        }
      }

      this.previousSelection = [...this.selectedPlatform];
    },
    handleModelPlatformSelection(selected) {
      const otherOptions = this.platformList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousModelPlatformSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedModelTrendlinePlatform = [...this.platformList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedModelTrendlinePlatform = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedModelTrendlinePlatform = [...this.platformList];
        } else {
          this.selectedModelTrendlinePlatform = [...selectedWithoutAll];
        }
      }

      this.previousModelPlatformSelection = [
        ...this.selectedModelTrendlinePlatform,
      ];
      this.getModalTrendlineGraphData();
    },
    handleTrendlinePlatformSelection() {
      this.getTrendlineData();
    },
    getTableData() {
      this.tableLoader = true;
      this.tableloader = true;
      const url = "api/india_clients/batch/price_tracking/table";
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      const payload = {
        timestamp: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        platforms: this.selectedPlatform
          ?.filter((item) => item.key !== "All")
          .map((p) => p.key),
        category_ids: this.finalSelectedCategory,
        brand_names: this.lossSelectedBrand
          ?.filter((item) => item.key !== "All")
          .map((b) => b.key),
        product_sku: this.lossSelectedProduct.map((p) => p.key),
        pincodes: this.lossSelectedPIN,
        price_range: this.lossSelectedPriceRange
          ?.filter((item) => item.key !== "all")
          .map((p) => p.key),
        batch: this.lossSelectedBatch.batch,
        include_child: true,
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.priceTrackingtableDataShow = res.data.data_present;
          this.tableLoader = false;
          this.tableloader = false;
          const resData = res.data.data;
          const modifiedTableData = resData.data;
          const headerData = resData.headers;
          this.storePriceTableData.header = [];
          this.storePriceTableData.data = modifiedTableData;
          this.storePriceTableData.header = headerData;
          this.$nextTick(() => {
            this.processTable("#price-tracking-table", 1);
          });
        })
        .catch((error) => {
          console.error("Error fetching table data:", error);
          this.tableLoader = false;
          this.tableloader = false;
        });
    },
    getTrendlineData() {
      this.trendlineLoader = true;
      const url = "api/v2/indian_clients/batch/price_tracking/product";
      this.viewNetSalesData = "";
      this.proccedNetSalesGraphData = null;
      const payload = {
        product_sku:
         this.lossSelectedProduct?.[0]?.key,
        start_date: this.trendlineDateRange.startDate,
        end_date: this.trendlineDateRange.endDate,
        platform: this.selectedTrendlinePlatform.key,
        pincode: this.trendlinePincode ? this.trendlinePincode : "",
        batch: this.lossSelectedBatch.batch,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.trendlineDataShow = res.data.data_present;
          this.trendlineLoader = false;
          this.viewNetSalesData = res.data.data.data;
          this.processNetSalesGraph();
        })
        .catch((error) => {
          console.error("Error fetching trendline data:", error);
          this.trendlineLoader = false;
        });
    },
    processNetSalesGraph() {
      const barChartMapper = Object.keys(this.viewNetSalesData[0]).filter(
        (key) => key != "timestamp"
      )[0];
      const colorMapper = [
        "#065559",
        "#F8CC44",
        "#FF4E4E",
        "#899EFC",
        "#46A493",
      ];
      const tempKey = Object.keys(this.viewNetSalesData[0]).filter(
        (key) => key !== "timestamp"
      );
      let data = {
        xAxis: [],
        seriesData: tempKey.map((data, idx) => {
          return {
            name: data,
            key: data,
            disableYLabel: false,
            color: colorMapper[idx],
            type: barChartMapper.includes(data) ? "column" : "line",
            marker: {
              enabled: true,
              lineWidth: 2,
              fillColor: "white",
              lineColor: colorMapper[idx],
              radius: 5,
            },
            data: [],
          };
        }),
      };
      this.viewNetSalesData?.forEach((obj) => {
        data.xAxis.push(moment(obj.timestamp).format("DD-MMM-YYYY"));
        data.seriesData.forEach((series, idx) => {
          data.seriesData[idx].data.push(obj[series.key]);
        });
      });
      this.proccedNetSalesGraphData = data;
    },
    processTable(id, sortCol = 0) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        sorting: [[sortCol, "desc"]],
        // scrollY: scrollVertical || false,
        initComplete: function (settings, json) {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });

      $(id + "_filter > label").append(`
        <div class='search_icon'>
            <img src='/Icons_SVG/Search.svg' width='20' />
        </div>
        `);
      //   var btn = $(
      //     '<input type="button" class="exportButton" value="Export" id="exportBtn"/>'
      //   );
      //   $(id + "_filter").append(btn);
      //   $("#exportBtn").click(function () {
      //     self.exportNow();
      //   });
    },
    getAllCategoryOption() {
      if (
        !this.translatedLang ||
        !this.selectedLanguage ||
        !this.translatedLang["All Categories"]
      ) {
        return {
          key: "",
          value: "All Categories",
        };
      }

      return {
        key: "",
        value:
          this.translatedLang["All Categories"][this.selectedLanguage.key] ||
          "All Categories",
      };
    },
    processTrendLineModal(productName, sku, pinCode, isChild) {
      this.procedModalTrandLineData = { xAxis: [] };
      // this.selectedPlatformTrendlineModal = [];
      this.selectedSegmentTrendlineModal = this.getAllCategoryOption();
      this.selectedProductTrendlineModal = productName;
      this.storeSKUForTrendLineModal = sku;
      this.selectedPinTrendLineModal = "";
      this.selectedPinTrendLineModal = String(pinCode);
      this.selectedModelTrendlinePlatform = this.platformList;
      this.previousModelPlatformSelection = this.platformList;
      this.isChild = isChild;
      this.getModalTrendlineGraphData(true, false);
      this.showTrendLineModal = true;
    },

    getModalTrendlineGraphData(getLoaderValue1, getLoaderValue2) {
      let self = this;
      self.trendLineGraphLoader = getLoaderValue2;
      self.firstTimeTrendLineLoader = getLoaderValue1;
      self.viewModalTrendLineData = [];
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }

      let url = "/api/v2/indian_clients/batch/price_tracking/trendline";

      let payload = {
        start_date: moment(this.modelTrendlineDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.modelTrendlineDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        sku: this.storeSKUForTrendLineModal,
        pincode: this.selectedPinTrendLineModal
          ? this.selectedPinTrendLineModal
          : "",
        platforms: this.selectedModelTrendlinePlatform
          ?.filter((val) => val.key != "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        batch: this.lossSelectedBatch.batch,
        child: this.isChild,
      };
      self.$http
        .post(url, payload)
        .then((res) => {
          this.onPriceTabletrendLineShowData = res.data.data_present;
          this.viewModalTrendLineData = res.data.data;
          this.processProductModalTrendlineGraph();
          self.trendLineGraphLoader = false;
          self.firstTimeTrendLineLoader = false;
        })
        .catch((err) => {
          this.$bvToast.toast("Error", {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 6000,
          });
          self.trendLineGraphLoader = false;
          self.firstTimeTrendLineLoader = false;
        });
    },
    processProductModalTrendlineGraph() {
      this.procedModalTrandLineData = {};
      let seriesData = [];
      let xAxisData = [];

      this.viewModalTrendLineData.forEach((items) => {
        xAxisData.push(moment(items.date).format("MMM DD, YY"));
        const processedSeries = new Set();

        items.price.forEach((data) => {
          const processedName = data.name.replace(/_/g, " ");
          if (!processedSeries.has(processedName)) {
            let series = seriesData.find((s) => s.name === processedName);
            if (!series) {
              series = {
                name: processedName,
                color: this.getColorForKey(processedName),
                tooltip: { valuePrefix: "₹" },
                marker: {
                  enabled: true,
                  lineWidth: 3,
                  fillColor: "#fff",
                  lineColor: this.getColorForKey(processedName),
                  radius: 4,
                  symbol: "circle",
                },
                dataLabels: {
                  enabled: false,
                  allowOverlap: true,
                  style: { fontWeight: "normal" },
                  formatter: function () {
                    return "₹" + this.point.y.toLocaleString();
                  },
                },
                data: [],
              };
              seriesData.push(series);
            }
            series.data.push(data.out_of_stock ? null : data.value);
            processedSeries.add(processedName);
          }
        });
      });

      this.procedModalTrandLineData = {
        id: "modalTrendLineGraph",
        xAxis: xAxisData,
        seriesData: seriesData,
        // yAxisTitle: "Price(₹)",
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}
.navigationButton {
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  padding: 5px 25px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
.outOfStockColor {
  color: #c00000;
}
</style>
<style>
 /* .exportButton {
    margin: 0px 10px;
    width: 100px;
    border: none;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px !important;
    font-weight: 600;
    padding: 5px !important;
    letter-spacing: 0.2px;
}

 .exportButton:hover {
    color: white !important;
    background: var(--primary_brand-80) !important;
    font-family: "poppins";
} */

 #disparity-filters .multiselect__strong {
  display: none !important;
}
</style>
